import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { APIService } from '../../services/api.service';
import { JobService } from '../../services/job.service.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SitemapComponent } from 'src/app/shared/sitemap/sitemap.component';

@Component({
  selector: 'app-job-search-results',
  templateUrl: './app-job-search-results.component.html',
  styleUrls: ['./app-job-search-results.component.scss'],
  standalone: false,
})
export class JobSearchResultsComponent implements OnInit {
  filters = {
    position: '',
    board: '',
    medium: '',
    level: '',
    subject: '',
    location: '',
    locationRange: '',
    salaryRange: '',
    datePosted: '',
    experience: '',
    employmentType: {
      fullTime: false,
      partTime: false,
      internship: false,
    },
  };

  jobs = [
    {
      id: 3,
      title: 'Primary School Teacher - Hindi ',
      location: 'Lucknow, Uttar Pradesh',
      type: 'Full-time',
      salary: '₹38,000 - ₹40,000',
      daysAgo: 4,
      school: 'Abhi',
      schoolLogo:
        'https://inforidain.blr1.cdn.digitaloceanspaces.com/641d7b024cb4ffd88c6a8611/school_logo/amgx6g1dbbij3wzkf2nc.jpg',
    },
    {
      id: 1,
      title: 'Middle School Teacher - English',
      location: 'Lucknow, Uttar Pradesh',
      type: 'Full-time',
      salary: '₹38,000 - ₹40,000',
      daysAgo: 4,
      school: 'Abhi',
      schoolLogo:
        'https://inforidain.blr1.cdn.digitaloceanspaces.com/6447a0bc710388a904f383aa/school_logo/kcs1rp748q9kxexn2b9p.jpg',
    },
    {
      id: 2,
      title: 'High School Teacher - Physics ',
      location: 'Lucknow, Uttar Pradesh',
      type: 'Full-time',
      salary: '₹38,000 - ₹40,000',
      daysAgo: 4,
      school: 'Abhi',
      schoolLogo:
        'https://inforidain.blr1.cdn.digitaloceanspaces.com/6625f829d0f52409df1b788e/school_logo/jzhhfzforcdo2ixkjoqq.jpg',
    },
    {
      id: 3,
      title: 'Primary School Teacher - Hindi ',
      location: 'Lucknow, Uttar Pradesh',
      type: 'Full-time',
      salary: '₹38,000 - ₹40,000',
      daysAgo: 4,
      school: 'Abhi',
      schoolLogo:
        'https://inforidain.blr1.cdn.digitaloceanspaces.com/641d7b024cb4ffd88c6a8611/school_logo/amgx6g1dbbij3wzkf2nc.jpg',
    },
    {
      id: 1,
      title: 'Middle School Teacher - English',
      location: 'Lucknow, Uttar Pradesh',
      type: 'Full-time',
      salary: '₹38,000 - ₹40,000',
      daysAgo: 4,
      school: 'Abhi',
      schoolLogo:
        'https://inforidain.blr1.cdn.digitaloceanspaces.com/6447a0bc710388a904f383aa/school_logo/kcs1rp748q9kxexn2b9p.jpg',
    },
    {
      id: 2,
      title: 'High School Teacher - Physics ',
      location: 'Lucknow, Uttar Pradesh',
      type: 'Full-time',
      salary: '₹38,000 - ₹40,000',
      daysAgo: 4,
      school: 'Abhi',
      schoolLogo:
        'https://inforidain.blr1.cdn.digitaloceanspaces.com/6625f829d0f52409df1b788e/school_logo/jzhhfzforcdo2ixkjoqq.jpg',
    },
    {
      id: 3,
      title: 'Primary School Teacher - Hindi ',
      location: 'Lucknow, Uttar Pradesh',
      type: 'Full-time',
      salary: '₹38,000 - ₹40,000',
      daysAgo: 4,
      school: 'Abhi',
      schoolLogo:
        'https://inforidain.blr1.cdn.digitaloceanspaces.com/641d7b024cb4ffd88c6a8611/school_logo/amgx6g1dbbij3wzkf2nc.jpg',
    },
    {
      id: 1,
      title: 'Middle School Teacher - English',
      location: 'Lucknow, Uttar Pradesh',
      type: 'Full-time',
      salary: '₹38,000 - ₹40,000',
      daysAgo: 4,
      school: 'Abhi',
      schoolLogo:
        'https://inforidain.blr1.cdn.digitaloceanspaces.com/6447a0bc710388a904f383aa/school_logo/kcs1rp748q9kxexn2b9p.jpg',
    },
    {
      id: 2,
      title: 'High School Teacher - Physics ',
      location: 'Lucknow, Uttar Pradesh',
      type: 'Full-time',
      salary: '₹38,000 - ₹40,000',
      daysAgo: 4,
      school: 'Abhi',
      schoolLogo:
        'https://inforidain.blr1.cdn.digitaloceanspaces.com/6625f829d0f52409df1b788e/school_logo/jzhhfzforcdo2ixkjoqq.jpg',
    },
    {
      id: 3,
      title: 'Primary School Teacher - Hindi ',
      location: 'Lucknow, Uttar Pradesh',
      type: 'Full-time',
      salary: '₹38,000 - ₹40,000',
      daysAgo: 4,
      school: 'Abhi',
      schoolLogo:
        'https://inforidain.blr1.cdn.digitaloceanspaces.com/641d7b024cb4ffd88c6a8611/school_logo/amgx6g1dbbij3wzkf2nc.jpg',
    },
    // Add more job data here
  ];

  locations = [
    'Near me',
    'Exact location',
    'Within 15 km',
    'Within 30 km',
    'Within 50 km',
  ];
  salaryRanges = ['30000K', '50000K', '80000K', '100000K'];

  boards = ['CBSE', 'ICSE', 'State Board'];
  mediums = ['English', 'Hindi', 'Regional'];
  levels = ['Primary', 'Secondary', 'Higher Secondary'];
  subjects = ['Mathematics', 'Science', 'English', 'History'];
  positions = ['Teacher', 'Lecturer', 'Principal'];

  totalJobs = 3177;
  location = 'Lucknow, Uttar Pradesh';

  constructor(
    private jobService: JobService,
    private router: Router,
    private meta: Meta
  ) {}

  ngOnInit(): void {
    this.searchJobs();
  }

  searchJobs(): void {
    console.log('Searching jobs with filters:', this.filters);
    // Implement job search logic here
  }

  applyForJob(jobId: number): void {
    console.log(`Applying for job ID: ${jobId}`);
    // Implement job application logic here
    this.router.navigate(['/job/detail']);
  }

  clearFilters(): void {
    this.filters = {
      position: '',
      board: '',
      medium: '',
      level: '',
      subject: '',
      location: '',
      locationRange: '',
      salaryRange: '',
      datePosted: '',
      experience: '',
      employmentType: {
        fullTime: false,
        partTime: false,
        internship: false,
      },
    };
    this.searchJobs();
  }
}
